import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { UnderwriterEditDto, MajorCompany, UserUnderwriter } from "interfaces/Mueller.Business.Models.ts";
import MCard, { MCardControlMethods, MCardField } from "components/Shared/MCard.tsx";
import * as yup from "yup";
import { DATA_TYPE_DROPDOWN2 } from "typeConstants/dataTypes";
import { getAllMajorCompanies } from "actions/user";
import { Button } from "react-md";
import { MDialog } from "components/Shared";


interface UnderwriterEditFormProps {
  underwriter: UserUnderwriter;
  onCancel: () => void;
  onSave: (underwriter: UnderwriterEditDto) => void;
  visible: boolean;
  //redux
  majorCompanies: MajorCompany[];
  getAllMajorCompanies: () => void;
}

const UnderwriterEditForm = (props: UnderwriterEditFormProps) => {
  const cardControlMethods = useRef<MCardControlMethods>();

  useEffect(() => {
    if (!props.majorCompanies) {
      props.getAllMajorCompanies();
    }
  });

  const handleSave = () => {
    if (!cardControlMethods.current.runValidation(true)) {
      return;
    }

    const cardData = cardControlMethods.current.getEditedDataObject(true);
    let underwriterEditDto: UnderwriterEditDto = null;

    underwriterEditDto = {
      id: props.underwriter.id,
      code: cardData.underwriterCode,
      email: cardData.underwriterEmail,
      majorCompanyId: cardData.underwriterMajorCompany,
    };

    props.onSave(underwriterEditDto);
  };

  const getCurrentMajorCompanyForField = () => {
    let currentMC = props.majorCompanies.find(mc => mc.id === props.underwriter.majorCompany.id);
    return {
      value: currentMC.id,
      label: currentMC.companyName
    };
  };

  const cardFields: MCardField[] = [
    {
      key: "underwriterCode",
      label: "Code",
      validation: yup.string().required("Underwriter code is required"),
      value: props.underwriter.underwriterCode,
      editable: true,
    },
    {
      key: "underwriterEmail",
      label: "Email",
      value: props.underwriter.emailAddress,
      validation: yup.string().nullable(),
      editable: true
    },
    {
      key: "underwriterMajorCompany",
      dataType: DATA_TYPE_DROPDOWN2,
      label: "Major Company",
      value: props.underwriter.majorCompany ? getCurrentMajorCompanyForField() : null,
      validation: yup.number().required("Major company is required"),
      dataTypeOptions: { options: props.majorCompanies.map(mc => ({ label: mc.companyName, value: mc.id })) },
      editable: true,
    },
  ];

  return (
    <MDialog
      className="underwriter-edit-dialog"
      children={
        <MCard
          key="underwriter-edit"
          className="underwriter-edit-card"
          title="Edit Underwriter"
          onlyEditable={true}
          fields={cardFields}
          getControlMethods={controlMethods => cardControlMethods.current = controlMethods}
        >
          <div className="underwriter-edit-button-container">
            <Button primary raised onClick={handleSave}>Save</Button>
            <Button primary raised onClick={props.onCancel}>Cancel</Button>
          </div>
        </MCard>}
      visible={props.visible}
      width={550}
    />
  );

};

const mapStateToProps = state => ({
  majorCompanies: state.customer.majorCompanies,
});

const mapDispatchToProps = dispatch => ({
  getAllMajorCompanies() {
    dispatch(getAllMajorCompanies());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(UnderwriterEditForm);